export default __webpack_public_path__ + "static/media/ProximaNova-Thin.88a64250.woff";